/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
import fetchCustomerLendingProfile from 'Utils/httpClients/fetchCustomerLendingProfile';
import { getFlagsWithRemote, parseFlagValue } from 'Utils/features';
import { FEATURE } from 'Services/Logger';
import AbstractFeatureFlagProvider from './AbstractFeatureFlagProvider';

export const REMOTE_FEATURE_FLAG_PROVIDER_ID = 'ADMIN_MONEY_FF';

export default class RemoteFeatureFlagProvider extends AbstractFeatureFlagProvider {
  constructor(priority, logger) {
    super(REMOTE_FEATURE_FLAG_PROVIDER_ID, priority, true);
    this._logger = logger;
  }

  async getFeatureFlags() {
    const flagsWithRemote = getFlagsWithRemote();
    return fetchCustomerLendingProfile(
      '/customer_lending_profile/api/v1/features',
      'GET',
      undefined,
      { 'Cache-Control': 'no-cache' },
    )
      .then(({ data: { features } }) => {
        Object.entries(features).forEach((feature) => {
          const [key, value] = feature;
          if (key in flagsWithRemote) {
            this.features.set(flagsWithRemote[key], parseFlagValue(value));
          }
        });
      })
      .catch((error) => {
        if (error.status === 401) return;
        this.error = error;
        this._logger && this._logger.error(
          'Error fetching or parsing remote feature flags',
          `${FEATURE.FEATURE_FLAGS}.RemoteFeatureFlagProvider.getFeatureFlags`,
          { error },
        );
      });
  }
}
